import {
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
} from "@mui/material";
import { ReactNode, useState } from "react";
import { Project } from "../../../types/project";
import dayjs, { Dayjs } from "dayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { WidthFull } from "@mui/icons-material";
import { addPostMeasurementDate } from "../../../api/project";
import { useApplicationContext } from "../../ContextProviders/ApplicationContext";
import { t } from "i18next";

type PostMeasurementDateDialogProps = {
  isDialogOpen: boolean;
  project: Project;
  handleClose: () => void;
  color: string;
  title: string;
  content: ReactNode;
};

export default function PostMeasurementDateDialog({
  isDialogOpen,
  project,
  handleClose,
  color,
  title,
  content,
  ...rest
}: PostMeasurementDateDialogProps) {
  const [value, setValue] = useState<Dayjs | null>(
    project.startDate2 ? dayjs(project.startDate2) : null
  );
  const [saveIsLoading, setSaveIsLoading] = useState(false);
  const { showSnackbar } = useApplicationContext();
  const handleStartDateSave = async () => {
    if (value) {
      setSaveIsLoading(true);

      project.startDate2 = value.toDate();
      try {
        let response = await addPostMeasurementDate(project);
        showSnackbar(
          t("post-measurement-start-date-updated-succesfully"),
          "success"
        );
        setSaveIsLoading(false);
      } catch (error) {
        showSnackbar(
          t("failed-to-update-post-measurement-start-date-try-again"),
          "error"
        );
        console.error("Error updating post-measurement date:", error);
        setSaveIsLoading(false);
      }
    }
  };
  return (
    <Dialog {...rest} open={isDialogOpen} onClose={handleClose}>
      <DialogTitle color={color} id="alert-dialog-title">
        {title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText component={"span"} id="alert-dialog-description">
          {content}
        </DialogContentText>
      </DialogContent>
      <Grid
        container
        xs
        spacing={3}
        marginTop={1}
        paddingRight={5}
        paddingLeft={5}
        justifyContent={"center"}
        alignContent={"center"}
        alignItems={"center"}
      >
        <Grid item xs={12} sm={12} md={8} lg={8} xl={8}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Start Date"
              value={value}
              onChange={(newValue) => setValue(newValue)}
              sx={{ width: "100%" }}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item xs={12} sm={12} md={4} lg={4} xl={4} height={"100%"}>
          <Button
            fullWidth
            sx={{ height: "100%" }}
            variant="contained"
            disabled={
              !value ||
              saveIsLoading ||
              value?.isSame(dayjs(project.startDate2), "day")
            }
            onClick={handleStartDateSave}
          >
            {saveIsLoading ? <CircularProgress color="inherit" /> : String(t('buttons.save'))}
          </Button>
        </Grid>
      </Grid>

      <Button sx={{ marginTop: 5, paddingBottom: 2 }} onClick={handleClose}>
        {String(t('buttons.close'))}
      </Button>
    </Dialog>
  );
}
